<div class="signup-page">

  <!-- Header -->
  <header class="signup-header">
    <a href="https://www.enact-systems.com" target="_blank">
      <img class="logo" src="/assets/images/login/enact-logo-light.png" alt="Enact Systems" />
    </a>
    <div class="header-right">
      <div class="header-social">
        <a href="https://www.facebook.com/Enact.Solar" target="_blank" rel="noopener noreferrer" title="Follow on Facebook"><i class="fa fa-facebook"></i></a>
        <a href="https://twitter.com/ENACTSOLAR" target="_blank" rel="noopener noreferrer" title="Follow on X"><i class="fa fa-twitter"></i></a>
        <a href="https://www.linkedin.com/company/enact-systems-inc" target="_blank" rel="noopener noreferrer" title="Follow on LinkedIn"><i class="fa fa-linkedin"></i></a>
        <a href="https://www.youtube.com/@enactsolar/" target="_blank" rel="noopener noreferrer" title="Follow on Youtube"><i class="fa fa-youtube"></i></a>
        <a href="https://www.instagram.com/enact_solar/" target="_blank" rel="noopener noreferrer" title="Follow on Instagram"><i class="fa fa-instagram"></i></a>
      </div>
      <a class="header-support" href="mailto:support&#64;enact-systems.com">support&#64;enact-systems.com</a>
    </div>
  </header>

  <!-- Content -->
  <div class="signup-content">

    <!-- Left: Marketing pitch -->
    <div class="signup-pitch">
      <p class="pitch-eyebrow">Enact Solar Software for Providers</p>
      <h1>Leading Solar Software for Providers</h1>
      <p class="pitch-subhead">Affordable and Accurate 3D Designs in Minutes</p>
      <p class="pitch-intro">
        Please fill out this quick form to receive access to a free 7-day trial of our solar design platform.
        No credit card required.
      </p>

      <img class="pitch-gif" src="/assets/images/Design-with-speed.gif" alt="Design with Speed" />

      <div class="pitch-section">
        <h3><i class="fa fa-pencil-square-o"></i> Design with Speed</h3>
        <ul>
          <li><strong>Roofs:</strong> Rapidly create roofs with automatic height and pitch detection using the Digital Surface Model (DSM) included in your subscription &amp; when it’s available in project area</li>
          <li><strong>Obstacles &amp; Trees:</strong> DSM when it’s available in project area detects heights automatically and typically updates every three months.</li>
          <li><strong>Shade:</strong> Run multiple scenarios with fast and accurate shading analysis and remove panels with poor solar access.</li>
        </ul>
      </div>

      <div class="pitch-section">
        <h3><i class="fa fa-file-text-o"></i> Build Proposals to Your Specific Needs</h3>
        <ul>
          <li><strong>Price:</strong> Set up multiple pricing templates that cater to your regions and exact customer types.</li>
          <li><strong>Add Finance:</strong> Set up preferred financing options (Loan, Lease, PPA) and compare cash flows.</li>
          <li><strong>Templates:</strong> Customize with colors, fonts, logos, dynamic graphs, 3D image sets, and more.</li>
        </ul>
      </div>

      <div class="pitch-section">
        <h3><i class="fa fa-battery-three-quarters"></i> Storage Made Easy</h3>
        <ul>
          <li><strong>Storage Savings:</strong> Predict additional savings with storage sizing, paired with solar, while selecting from any brand.</li>
          <li><strong>Insights:</strong> Visualize battery charge and discharge cycles for any day of the year with Time-of-Use (TOU) simulations.</li>
        </ul>
      </div>

      <div class="pitch-section">
        <h3><i class="fa fa-bolt"></i> Complex Rates Demystified</h3>
        <ul>
          <li><strong>Tariffs:</strong> Pull up rates in any zip code and their associated billing structures for both current and proposed designs. May attract additional fees for USA.</li>
          <li><strong>Accurate Global Calculations:</strong> Net Billing algorithm forecasts savings with storage during evening hours.</li>
        </ul>
      </div>

      <div class="pitch-section">
        <h3><i class="fa fa-plug"></i> API Connect &amp; E-sign</h3>
        <ul>
          <li><strong>Lead API:</strong> Create and update leads from your website or CRM directly into Enact. May attract additional fees.</li>
          <li><strong>Design API:</strong> Sync design data to any leading CRM or custom application through our open API. May attract additional fees.</li>
          <li><strong>E-signatures:</strong> DocuSign your proposals and contracts to swiftly close sales.</li>
        </ul>
      </div>

      <div class="pitch-section">
        <h3><i class="fa fa-line-chart"></i> Post-Installation Asset Management</h3>
        <ul>
          <li><strong>Aggregated Dashboard:</strong> View all of your systems performance in one place from single portal, with most major inverter brands supported.</li>
          <li><strong>System Health at a Glance:</strong> Understand system status and proactively identify customer issues.</li>
        </ul>
      </div>

      <div class="pitch-features">
        <div class="feature-tag"><i class="fa fa-check-circle"></i> 3D Design</div>
        <div class="feature-tag"><i class="fa fa-check-circle"></i> Proposals &amp; Finance</div>
        <div class="feature-tag"><i class="fa fa-check-circle"></i> Storage Sizing</div>
        <div class="feature-tag"><i class="fa fa-check-circle"></i> Rate Analysis</div>
        <div class="feature-tag"><i class="fa fa-check-circle"></i> API Connect</div>
        <div class="feature-tag"><i class="fa fa-check-circle"></i> E-sign</div>
      </div>
    </div>

    <!-- Right: Form card -->
    <div class="signup-card">

      <h2>Start Your Free 7-Day Trial</h2>

      <div *ngIf="success" class="success-message">
        <h3>Account created!</h3>
        <p>Check your email for your login credentials. Your trial is valid for 7 days.</p>
        <a class="back-to-signin" [href]="loginUrl">Sign In</a>
      </div>

      <div *ngIf="pendingInquiry" class="success-message">
        <h3>Thank you for your interest!</h3>
        <p>{{ pendingMessage }}</p>
      </div>

      <form *ngIf="!success && !pendingInquiry" (ngSubmit)="submit()" #f="ngForm">

        <!-- Step indicator -->
        <div class="step-indicator">
          <div class="step active">
            <span class="step-dot">{{ emailVerified ? '✓' : '1' }}</span>
            <span class="step-label">Verify Email</span>
          </div>
          <div class="step-line" [class.complete]="emailVerified"></div>
          <div class="step" [class.active]="emailVerified">
            <span class="step-dot">2</span>
            <span class="step-label">Your Details</span>
          </div>
        </div>

        <!-- Email with inline OTP verification — always visible first -->
        <div class="form-group">
          <label>Email *
            <span *ngIf="emailVerified" class="verified-badge">&#10003; Verified</span>
            <button *ngIf="emailVerified || otpSent" type="button" class="change-email-btn" (click)="changeEmail()">Change</button>
          </label>
          <div class="email-otp-row">
            <input type="email" [(ngModel)]="form.email_id" name="email_id" required
                   placeholder="Work Email"
                   pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                   [readonly]="emailVerified || otpSent"
                   [class.input-verified]="emailVerified"
                   #emailInput="ngModel" />
            <button type="button" class="send-code-btn"
                    *ngIf="!emailVerified"
                    (click)="sendOtp()"
                    [disabled]="otpSending || otpSent || emailInput.invalid">
              {{ otpSending ? 'Sending...' : (otpSent ? 'Code Sent' : 'Send Code') }}
            </button>
          </div>
          <div *ngIf="emailInput.invalid && emailInput.dirty && !otpSent" class="error-msg">
            Please enter a valid email address.
          </div>
          <div *ngIf="otpEmailError" class="error-msg">
            {{ otpEmailError }}
            <a *ngIf="otpEmailConflict" [href]="loginUrl" class="error-signin-link">Sign In</a>
          </div>

          <!-- OTP input — shown after code is sent, hidden once verified -->
          <div *ngIf="otpSent && !emailVerified" class="otp-inline">
            <input type="text" [(ngModel)]="otpValue" [ngModelOptions]="{standalone: true}"
                   maxlength="6" placeholder="Enter 6-digit code"
                   class="otp-input" autocomplete="one-time-code"
                   (ngModelChange)="onOtpInput()"
                   #otpInput />
            <button type="button" class="send-code-btn verify-btn"
                    (click)="verifyOtp()" [disabled]="otpLoading || otpValue.length < 6">
              {{ otpLoading ? 'Verifying...' : 'Verify' }}
            </button>
          </div>
          <div *ngIf="otpError" class="error-msg">
            {{ otpError }}
            <span *ngIf="attemptsRemaining !== null && attemptsRemaining > 0" class="attempts-remaining">
              ({{ attemptsRemaining }} attempt{{ attemptsRemaining === 1 ? '' : 's' }} remaining)
            </span>
          </div>
          <div *ngIf="otpSent && !emailVerified" class="resend-row">
            <span>Didn't receive the code?</span>
            <button type="button" class="resend-btn" (click)="resendOtp()" [disabled]="resendCooldown > 0">
              {{ resendCooldown > 0 ? 'Resend in ' + resendCooldown + 's' : 'Resend Code' }}
            </button>
          </div>
        </div>

        <!-- Rest of form — only shown after email is verified -->
        <ng-container *ngIf="emailVerified">

        <!-- Name -->
        <div class="form-row">
          <div class="form-group">
            <label>First Name *</label>
            <input type="text" [(ngModel)]="form.fn" name="fn" required placeholder="First Name" />
          </div>
          <div class="form-group">
            <label>Last Name *</label>
            <input type="text" [(ngModel)]="form.ln" name="ln" required placeholder="Last Name" />
          </div>
        </div>

        <!-- Phone -->
        <div class="form-group">
          <label>Phone *</label>
          <input type="tel" [(ngModel)]="form.phone_number" name="phone_number" placeholder="Phone Number" />
        </div>

        <!-- Company -->
        <div class="form-group">
          <label>Company *</label>
          <input type="text" [(ngModel)]="form.bn" name="bn" required placeholder="Company Name" />
        </div>

        <!-- Country -->
        <div class="form-row">
          <div class="form-group">
            <label>Country *</label>
            <!-- Hidden input carries required validation for ngForm -->
            <input type="hidden" [(ngModel)]="form.country" name="country"
                   [required]="!isOtherCountry" />
            <div class="multiselect-dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="multiselect-trigger"
                      (click)="toggleCountryDropdown()"
                      [disabled]="countriesLoading"
                      [class.placeholder]="!form.country && !isOtherCountry">
                <span>{{ countriesLoading ? 'Loading...' : (isOtherCountry ? 'Other' : (form.country || '-- Select --')) }}</span>
                <i class="fa" [class.fa-chevron-down]="!countryOpen" [class.fa-chevron-up]="countryOpen"></i>
              </button>
              <div class="country-dropdown-panel" *ngIf="countryOpen">
                <div class="country-search-wrap">
                  <input id="country-search-input" type="text" [(ngModel)]="countrySearch"
                         [ngModelOptions]="{standalone: true}"
                         placeholder="Search..." class="country-search-input"
                         (click)="$event.stopPropagation()" />
                </div>
                <div class="country-options-scroll">
                  <div *ngFor="let c of filteredCountries"
                       class="country-option"
                       [class.selected]="(!isOtherCountry && form.country === c) || (isOtherCountry && c === 'Other')"
                       (click)="selectCountry(c)">
                    {{ c }}
                  </div>
                  <div *ngIf="filteredCountries.length === 0" class="country-no-results">No results</div>
                </div>
              </div>
            </div>
            <!-- Shown only when "Other" is selected -->
            <input *ngIf="isOtherCountry" type="text"
                   [(ngModel)]="otherCountryText" [ngModelOptions]="{standalone: true}"
                   placeholder="Enter your country" class="other-country-input" />
          </div>
        </div>

        <!-- City / Zip -->
        <div class="form-row">
          <div class="form-group">
            <label>City *</label>
            <input type="text" [(ngModel)]="form.city" name="city" required placeholder="City" />
          </div>
          <div class="form-group">
            <label>Zip *</label>
            <input type="text" [(ngModel)]="form.zip" name="zip" required placeholder="Zip Code" />
          </div>
        </div>

        <!-- How did you hear about us -->
        <div class="form-group">
          <label>How did you hear about us? *</label>
          <select [(ngModel)]="form.lead_source" name="lead_source" required>
            <option value="">-- Select --</option>
            <option *ngFor="let opt of leadSourceOptions" [value]="opt">{{ opt }}</option>
          </select>
        </div>

        <!-- Business type -->
        <div class="form-group">
          <label>Most of my company's business is in *</label>
          <div class="multiselect-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="multiselect-trigger" (click)="toggleBusinessTypeDropdown()"
                    [class.placeholder]="!form.business_type.length">
              <span>{{ businessTypeLabel }}</span>
              <i class="fa" [class.fa-chevron-down]="!businessTypeOpen" [class.fa-chevron-up]="businessTypeOpen"></i>
            </button>
            <div class="multiselect-options" *ngIf="businessTypeOpen">
              <label *ngFor="let opt of businessTypeOptions" class="checkbox-label">
                <input type="checkbox"
                       [value]="opt"
                       [checked]="form.business_type.includes(opt)"
                       (change)="onBusinessTypeChange($event, opt)" />
                {{ opt }}
              </label>
            </div>
          </div>
        </div>

        <!-- Types of Projects (multi-select dropdown) -->
        <div class="form-group">
          <label>Types of Projects *</label>
          <div class="multiselect-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="multiselect-trigger" (click)="toggleProjectTypeDropdown()"
                    [class.placeholder]="!form.project_types.length">
              <span>{{ projectTypeLabel }}</span>
              <i class="fa" [class.fa-chevron-down]="!projectTypeOpen" [class.fa-chevron-up]="projectTypeOpen"></i>
            </button>
            <div class="multiselect-options" *ngIf="projectTypeOpen">
              <label *ngFor="let opt of projectTypeOptions" class="checkbox-label">
                <input type="checkbox"
                       [value]="opt"
                       [checked]="form.project_types.includes(opt)"
                       (change)="onProjectTypeChange($event, opt)" />
                {{ opt }}
              </label>
            </div>
          </div>
        </div>

        <!-- Project Size -->
        <div class="form-group">
          <label>Project Size *</label>
          <select [(ngModel)]="form.project_size" name="project_size" required>
            <option value="">-- Select --</option>
            <option *ngFor="let opt of projectSizeOptions" [value]="opt">{{ opt }}</option>
          </select>
        </div>

        <!-- Designs per month -->
        <div class="form-group">
          <label>Estimated Number of Designs (per month) *</label>
          <select [(ngModel)]="form.designs_per_month" name="designs_per_month" required>
            <option value="">-- Select --</option>
            <option *ngFor="let opt of designsPerMonthOptions" [value]="opt">{{ opt }}</option>
          </select>
        </div>

        <!-- Number of users -->
        <div class="form-group">
          <label>How Many Users? *</label>
          <input type="number" [(ngModel)]="form.num_users" name="num_users" required min="1" placeholder="Number of users" />
        </div>

        <div *ngIf="errorMsg" class="error-msg">{{ errorMsg }}</div>

        <button type="submit" [disabled]="loading || !f.valid">
          {{ loading ? 'Creating account...' : 'Start Free Trial' }}
        </button>

        </ng-container>

        <a class="back-to-signin" [href]="loginUrl">Back to Sign In</a>

      </form>
    </div>

  </div>


</div>
